import * as actions from './actions';

export { default as types, moduleName as NAME } from './types';

export default actions;
